import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.TabA');
    const { locale = 'us' } = useRouter();

    const IS_NA_SITE = ['us', 'ca', 'mx'].includes(locale);
    const IS_EU_SITE = ['de', 'fr', 'it', 'es', 'eu', 'uk', 'nl', 'kr'].includes(locale);
    const props = {
        theme: 'white',
        loop: true,
        navigation: true,
        pagination: false,
        gap: 0,
        lists: [
            {
                tab: t('a_tab'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729591281165/pc_1.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1729591281165/pc_1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729591307911/m_1.jpg',
                title: t('a_tab'),
                desc: t.rich('a_desc', {
                    sup: (text: string) => <sup className="sup">{text}</sup>,
                }),
            },
            {
                tab: t('b_tab'),
                pc:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730684901651/pc_On-the-go.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1743147946237/pc.jpg',
                pad:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730684901651/pc_On-the-go.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1743147946237/pc.jpg',
                h5:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730684901480/m_On-the-go.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1743147945951/m.png',
                title: t('b_tab'),
                desc: t.rich('b_desc', {
                    sup: (text: string) => <sup className="sup">{text}</sup>,
                }),
            },
            !IS_NA_SITE &&
                !IS_EU_SITE && {
                    tab: t('c_tab'),
                    pc:
                        locale === 'jp'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1754037071650/2.png'
                            : 'https://websiteoss.ecoflow.com/upload/image/1729591281382/pc_2.jpg',
                    pad:
                        locale === 'jp'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1754037071650/2.png'
                            : 'https://websiteoss.ecoflow.com/upload/image/1729591281382/pc_2.jpg',
                    h5:
                        locale === 'jp'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1754037071650/2.png'
                            : 'https://websiteoss.ecoflow.com/upload/image/1729591281915/m_2.jpg',
                    title: t('c_tab'),
                    desc: t.rich('c_desc', {
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    }),
                },
        ].filter(Boolean),
    };

    return (
        <div className={`${css.comp} rapid-G`}>
            <EfSpec />
            <EfSwiperTab {...props} />
            <EfSpec />
        </div>
    );
}
